import { css } from '@microsoft/fast-element';

export const MultiSegmentedControlStyles = css`
  :host {
    display: contents;
  }

  .segmented-options-hide-control {
    border: 1px solid var(--primary-color);
    border-radius: 4px;
  }

  .segmented-options {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 28px;
    margin: calc(var(--design-unit) * 1px) 0;
  }

  zero-checkbox.hide-control {
    justify-content: center;
    border-right: 1px solid var(--primary-color);
    margin: 0;
    height: 100%;
    flex: 1;
  }

  zero-checkbox.hide-control::part(control) {
    display: none;
  }

  zero-checkbox::part(label) {
    color: var(--neutral-stroke-rest);
    font-size: var(--type-ramp-minus-1-font-size);
  }

  zero-checkbox.checked.hide-control::part(label) {
    color: var(--white);
  }

  zero-checkbox.checked.hide-control {
    background: linear-gradient(90deg, rgb(205 172 31 / 50%) 35%, rgb(116 230 74 / 50%) 100%);
  }

  zero-checkbox:last-child {
    border-right: 0;
  }
`;
